<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
 @import './common/styles/base.css';
</style>



// WEBPACK FOOTER //
// src/App.vue